import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-checkbox-partial",
  "use": "tamr-icon-checkbox-partial-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-checkbox-partial\"><path d=\"M31,0H1A1,1,0,0,0,0,1V31a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V1A1,1,0,0,0,31,0ZM30,30H2V2H30V30Z\" /><path d=\"M8,17H24a1,1,0,0,0,0-2H8A1,1,0,0,0,8,17Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol